//  ReviewCompletedTests.js
//
//  Updated 2/2.
//
//  Abstract: Review test results PDF.

//	React
import React, { useState } from 'react';
import axios from 'axios';

//	Material-ui components
import { makeStyles, CssBaseline, Container  } from '@material-ui/core';

//	CSS styles
const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	progess: {
		position: 'absolute'
	}
}));

export default function ReviewCompletedTests(props) {

	//	CSS classes
	const classes = useStyles();

	//	Set state
	
	//	Component rendering
    return (
        <>
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <p>ReviewCompletedTests</p>
            </Container>
        </>
    );
}